import { render } from "./Profile-Own.vue?vue&type=template&id=0d51649d"
import script from "./Profile-Own.vue?vue&type=script&lang=js"
export * from "./Profile-Own.vue?vue&type=script&lang=js"

import "./Profile-Own.vue?vue&type=style&index=0&id=0d51649d&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__